module.exports = __webpack_public_path__ + "static/media/Trophy1.6f3d276b.svg";